import React, { useEffect, useState } from "react";

const SIZES: Record<string, string> = {
  sm: "h-10 w-10 text-sm",
  md: "h-14 w-14 text-lg",
  lg: "h-24 w-24 text-3xl",
};

interface StudentAvatarProps {
  src?: string | null;
  name?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

/**
 * Round avatar for student-owned records (profile icon, notification senders).
 * Falls back to the first character of `name` when there is no image or the
 * image fails to load.
 */
const StudentAvatar: React.FC<StudentAvatarProps> = ({
  src,
  name = "",
  size = "md",
  className = "",
}) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const dimension = SIZES[size] ?? SIZES.md;

  if (!src || failed) {
    return (
      <span
        className={`flex shrink-0 items-center justify-center rounded-full bg-[#ffa217] font-bold uppercase text-white ${dimension} ${className}`}
      >
        {name.trim().charAt(0) || "?"}
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={name}
      onError={() => setFailed(true)}
      className={`shrink-0 rounded-full border border-gray-100 object-cover ${dimension} ${className}`}
    />
  );
};

export default StudentAvatar;
